import { createStore } from 'vuex'
import axios from 'axios'
import { auth } from './auth.module';

export const API_URL = `${process.env.VUE_APP_API_URL}/api/token/`;

export default createStore({
  state: {
    showMenu: false,
    cars: [],
    companies: [],
    reports: [],
    checklists: [],
    answers: [],
    count_checklists: [],
    lastEquipmentData: [],
    appeals: [],
    stop_reports: [],
    production: [],
    statistic: [],
    polygon_company: [],
    polygon_orders: [],
    polygon_events: [],
    waste_types: [],
    waste_cars: [],
    eco_partners: [],
    eco_contracts: [],
    eco_waste_reports: [],
    eco_partner_waste_reports: [],
    domain: process.env.VUE_APP_API_URL
  },
  getters: {
    domain: state => state.domain,
  },
  mutations: {
    toggleShowMenu(state) {
      state.showMenu = !state.showMenu;
    },
    setCarData(state, carData) {
      state.cars = carData.map(car => {
        return {
          id: car.id,
          number: car.number,
          comment: car.comment,
          company: car.company
        };
      });
    },
    setCompanyData(state, companyData) {
      state.companies = companyData.map(company => {
        return {
          id: company.id,
          name: company.name,
          comment: company.comment,
        };
      });
    },
    setReportData(state, reportData) {
      state.reports = reportData.map(report => {
        return {
          id: report.id,
          title: report.title,
          car_necessary: report.car_necessary,
          period_necessary: report.period_necessary,
          finish_checklists: report.finish_checklists,
          questions: report.questions,
          comment: report.comment,
          group: report.group,
        };
      });
    },
    setLastEquipmentData(state, lastEquipmentData) {
      state.lastEquipmentData = lastEquipmentData.map(lastEquipmentData => {

        return {
          id: lastEquipmentData.id,
          name: lastEquipmentData.name,
          value: lastEquipmentData.value,
        };
      });
    },
    setAppealData(state, appealData) {
      state.appeals = appealData.map(appeal => {
        return {
          id: appeal.id,
          cid: appeal.kp_number,
          comment: appeal.comment,
          image: appeal.image,
          created_at: appeal.created_at
        };
      });
    },
    setStopReports(state, stopReportsData) {
      state.stop_reports = stopReportsData.map(stop_report => {
        return {
          id: stop_report.id,
          created_at: stop_report.created_at,
          finished_at: stop_report.finished_at,
          stop_period: stop_report.stop_period,
          status: stop_report.status,
        };
      });
    },
    setProductionData(state, productionData) {
      state.production = productionData.map(production => {
        return {
          id: production.id,
          batch: production.batch,
          product: production.product,
          weight: production.weight,
          created_at: production.created_at,
        };
      });
    },
    setChecklistData(state, checklistData) {
      state.checklists = checklistData.map(checklist => {
        return {
          id: checklist.id,
          report_title: checklist.report_title,
          company_name: checklist.company_name,
          car_number: checklist.car_number,
          answers: checklist.answers,
          finish: checklist.finish,
          period: checklist.period,
          created_at: checklist.created_at,
        };
      });
    },
    setAnswersData(state, answersData) {
      state.answers = answersData.map(answer => {
        return {
          id: answer.id,
          question: answer.question,
          comment: answer.comment,
          answer_result: answer.answer_result,
          image: answer.image,
          period_at: answer.period_at,
          created_at: answer.created_at,
        };
      });
    },
    setStatisticData(state, statisticData) {
      state.statistic = statisticData.map(statistic => {
        return {
          report_title: statistic.report_title,
          company_name: statistic.company_name,
          yes_answers: statistic.yes_answers_count,
          no_answers: statistic.no_answers_count,
          empty_answers: statistic.empty_answers_count,
          period: statistic.period,
        };
      });
    },
    setPolygonCompanyData(state, polygonCompanyData) {
      state.polygon_company = polygonCompanyData
    },
    setPolygonOrdersData(state, polygonOrdersData) {
      state.polygon_orders = polygonOrdersData
    },
    setPolygonEventsData(state, polygonEventsData) {
      state.polygon_events = polygonEventsData
    },
    setWasteTypes(state, wasteTypesData) {
      state.waste_types = wasteTypesData
    },
    setCars(state, carsData) {
      state.waste_cars = carsData
    },
    setEcoPartners(state, ecoPartnersData) {
      state.eco_partners = ecoPartnersData
    },
    setEcoContracts(state, ecoContractsData) {
      state.eco_contracts = ecoContractsData
    },
    setEcologyWasteReports(state, ecoWasteReportsData) {
      state.eco_waste_reports = ecoWasteReportsData
    },
    setEcologyPartnerWasteReports(state, ecoPartnerWasteReportsData) {
      state.eco_partner_waste_reports = ecoPartnerWasteReportsData
    },
  },
  actions: {
    toggleShowMenu({ commit }) {
      commit('toggleShowMenu');
    },
    fetchCars({ commit, state }) {
      const baseURL = state.domain + "/api/cars/";

      axios
        .get(baseURL)
        .then(response => {
          commit("setCarData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchCompanies({ commit, state }) {
      const baseURL = state.domain + "/api/companies/";

      axios
        .get(baseURL)
        .then(response => {
          commit("setCompanyData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchReports({ commit, state }) {
      const baseURL = state.domain + "/api/protection/";

      axios
        .get(baseURL)
        .then(response => {
          commit("setReportData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchAppeals({ commit, state }, date) {
      const baseURL = state.domain + "/api/appeals/";
      console.log(date[0])
      const params = {
        start_date: date[0],
        end_date: date[1]
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          commit("setAppealData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchLastEquipmentParams({ commit, state }) {
      const baseURL = state.domain + "/api/equipment/parameters/last";

      axios
        .get(baseURL)
        .then(response => {
          commit("setLastEquipmentData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchChecklists({ commit, state }, reportId ) {
      if (typeof reportId != 'undefined') {
        const baseURL = state.domain + '/api/protection/'+reportId;
        axios
          .get(baseURL)
          .then(response => {
            commit("setChecklistData", response.data);
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        const baseURL = state.domain + '/api/checklists/';
        axios
          .get(baseURL)
          .then(response => {
            commit("setChecklistData", response.data);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    fetchAnswers({ commit, state }, ChecklistId ) {
        const baseURL = state.domain + '/api/answers/'+ChecklistId;
        axios
          .get(baseURL)
          .then(response => {
            commit("setAnswersData", response.data);
          })
          .catch(e => {
            console.log(e);
          });
    },
    fetchStopReport({ commit, state }) {
      const baseURL = state.domain + '/api/stopreports/';
      axios
        .get(baseURL)
        .then(response => {
          commit("setStopReports", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchProduction({ commit, state }, date) {
      const baseURL = state.domain + '/api/production/';

      const params = {
        start_date: date[0],
        end_date: date[1]
      }
      // console.log(params)
      axios
        .get(baseURL, { params })
        .then(response => {
          commit("setProductionData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchStatistic({ commit, state }, date) {
      const baseURL = state.domain + '/api/statistic/';

      const params = {
        start_date: date[0],
        end_date: date[1]
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          commit("setStatisticData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchPolygonContracts({ commit, state }, inn) {
      const baseURL = state.domain + '/api/polygon/check_inn';
      console.log('INN', inn[0])
      const params = {
        "CompanyINN": inn[0]
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          console.log(response.data);
          commit("setPolygonCompanyData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchPolygonOrders({ commit, state }, data) {
      const baseURL = state.domain + '/api/polygon/check_orders';

      const params = {
        "CompanyINN": data.inn[0],
        "StartDate": data.start_date,
        "EndDate": data.end_date,
      }
      console.log(params)
      axios
        .get(baseURL, { params })
        .then(response => {
          console.log(response.data);
          commit("setPolygonOrdersData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchPolygonEvents({ commit, state }, inn) {
      const baseURL = state.domain + '/api/polygon/get_events';
      console.log('Event INN', inn[0])
      const params = {
        "CompanyINN": inn[0],
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          console.log(response.data);
          commit("setPolygonEventsData", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchWasteTypes({ commit, state }) {
      const baseURL = state.domain + '/api/polygon/waste_types';
      axios
        .get(baseURL)
        .then(response => {
          commit("setWasteTypes", response.data);
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchWasteCars({ commit, state }, inn) {
      const baseURL = state.domain + '/api/polygon/waste_cars';
      const params = {
        "CompanyINN": inn[0],
      }

      axios
        .get(baseURL, { params })
        .then(response => {
          commit("setCars", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchEcologyPartners({ commit, state }) {
      const baseURL = state.domain + '/api/ecology/partners';
      axios
        .get(baseURL)
        .then(response => {
          commit("setEcoPartners", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchEcologyContracts({ commit, state }) {
      const baseURL = state.domain + '/api/ecology/contracts';
      axios
        .get(baseURL)
        .then(response => {
          commit("setEcoContracts", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchEcologyWasteReports({ commit, state }, data) {
      const baseURL = state.domain + '/api/ecology/waste_reports';

      const params = {
        "DateStart": data.start_date,
        "DateFinish": data.finish_date,
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          commit("setEcologyWasteReports", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchEcologyPartnerWasteReports({ commit, state }, data) {
      const baseURL = state.domain + '/api/ecology/partner_waste_reports';
      console.log(data)

      const params = {
        "CompanyINN": data.company_inn,
        "DateStart": data.start_date,
        "DateFinish": data.finish_date,
      }
      axios
        .get(baseURL, { params })
        .then(response => {
          console.log(response.data)
          commit("setEcologyPartnerWasteReports", response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  modules: {
    auth
  }
});


